import Button from '@components/Button';
import Row from '@components/Row';
import Stepper from '@components/Stepper';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import useAppCustom from '@hooks/useAppCustom';
import { OrderLine } from '@models/order';
import { useTranslation } from 'react-i18next';

import useModifyCartItem from './hooks/useModifyCartItem';

interface Props {
    item: OrderLine;
}

function CartFooter({ item }:Props) {
    const { t } = useTranslation('cart');
    const { handleDecrease, handleIncrease, handleDelete } = useModifyCartItem(item);
    const { itemMaxQuantity } = useAppCustom().item;
    const { quantity } = item;
    return (
        <Row fullWidth justify='space-between'>
            <StepperWrapper>
                <Stepper value={quantity}
                    max={itemMaxQuantity}
                    min={1}
                    increase={handleIncrease}
                    decrease={handleDecrease} />
            </StepperWrapper>
            <Button css={buttonCss} onClick={handleDelete}>
                {t('item.delete')}
            </Button>
        </Row>
    );
}

const StepperWrapper = styled.div`
    width: 100px;
`;

const buttonCss = css`
    height: 36px !important;
    width: 100px !important;
`;

export default CartFooter;
